import React, { useEffect, useState } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { AddBox } from "@mui/icons-material";
import {
  Autocomplete,
  Checkbox,
  ListItemText,
  MenuItem,
  TextField,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { useSelector } from "react-redux";
const highlightParenthesesText = (text) => {
  return text.replace(/\(([^)]+)\)/g, "(<i>$1</i>)");
};
export const AccountInput = ({
  isOptionEqualToValue,
  error,
  disabled,
  value,
  onChange,
  options,
  id,
  addAccountModal,
  label,
  disableClearable,
}) => {
  let Option = options
  const companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29]
  let setArrayAll = companyDetails?.relatedcompanydetailsnew?.[0].registrationtype !== 1 ? [...Option] : Option.filter((e) => !GSTArrayValues.includes(e.value))
  return (
    <>
      <Autocomplete
        openOnFocus
        id={id}
        disableClearable={disableClearable === true}
        ListboxProps={{
          style: { paddingTop: 0 }, // Ensure top padding is removed
        }}
        options={[
          "Add Accounts",
          ...Option.sort((a, b) => {
            if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
            if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
            return 0;
          }),
        ]}
        isOptionEqualToValue={isOptionEqualToValue}
        disabled={disabled}
        clearIcon={
          value !== "" ? <ClearIcon style={{ fontSize: "20px" }} /> : null
        }
        value={value}
        onChange={onChange}
        size="small"
        renderOption={(props, option) => (
          <>
            {option === "Add Accounts" ? (
              <MenuItem
                value={"addAccount"}
                onClick={(e) => {
                  e.stopPropagation();
                  addAccountModal(true);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "sticky",
                  //   mt: "-8px !important",
                  top: "0px !important",
                  backgroundColor: grey[50],
                  "&:hover": {
                    backgroundColor: grey[200],
                  },
                }}
              >
                <AddBox
                  fontSize="small"
                  sx={{
                    marginRight: "5px",
                    color: "primary.main",
                  }}
                />
                <ListItemText
                  sx={{ color: "primary.main" }}
                  primary={"Add Accounts"}
                />
              </MenuItem>
            ) : (
              <li {...props}>
                <span>
                  <b>{option.label}</b>{" "}
                  {option?.groupName?.length ? (
                    <i>({option?.groupName?.trim()})</i>
                  ) : (
                    ""
                  )}
                </span>
              </li>
              // <MenuItem
              //     {...props}
              //     key={option.value}
              //     value={option.value}
              // >
              //     <ListItemText primary={<span  ><b>{option.label}</b> {option?.groupName?.length ? <i>({option?.groupName?.trim()})</i> : ""}</span>} />
              // </MenuItem>
            )}
          </>
        )}
        renderInput={(params) => (
          <TextField
            error={error}
            sx={{
              ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "8.5px 7px",
              },
              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                fontSize: "14px",
              },
              label: {
                fontSize: "14px",
              },
              ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                fontSize: "14px",
              },
              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                color: "input.font",
              },
              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                borderColor: "input.border",
              },
              ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                color: "input.font",
              },
              ".css-14qz1ij-MuiListItemText-root": {
                margin: "0px",
              },
              ".css-wgai2y-MuiFormLabel-asterisk": {
                color: "danger.main",
              },
              "& .MuiAutocomplete-endAdornment svg": {
                 color: "black",
               },
            }}
            label={label}
            InputLabelProps={{
              shrink: true,
            }}
            {...params}
          />
        )}
      />
    </>
  );
};
export const AccountInputv2 = ({
  error,
  isOptionEqualToValue,
  disabled,
  value,
  onChange,
  options,
  id,
  addAccountModal,
  label,
  disableClearable,
  onKeyDown,
  filter=[7,15]
}) => {
  // for receipt, includes showall
  let Option = options
  const [displayAllAccounts, setDisplayAllAccounts] = useState(false);
  const companyDetails = useSelector(
    (state) => state?.companyReducer?.companyDetails
  );
  let GSTArrayValues = [4, 5, 6, 7, 8, 9, 10, 11, 19, 20, 29]
  const sortOptionsByAccountGroupID = (Option) => {
    // return empty array if no Option found
    Option = companyDetails?.relatedcompanydetailsnew?.[0].registrationtype !== 1 ? [...Option] : Option.filter((e) => !GSTArrayValues.includes(e.value))
    Option = [
      ...Option.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) return -1;
        if (a.label.toLowerCase() > b.label.toLowerCase()) return 1;
        return 0;
      }),
    ];
    if (!Option || Option?.length === 0) {
      return [];
    }
    //if show all return Option after sorting to make trade rece.. and trade payable to first
    if (displayAllAccounts) {
      // This code sorts an array of account options based on two criteria:
   // 1. Priority: Accounts with AccountGroupID of 15 or 7 are given higher priority (0) vs others (1)
   // 2. Alphabetical order: Within same priority, sorts by account label alphabetically
   return Option.sort((a, b) => {
        // Assign priority 0 to accounts with ID 15 or 7 or path containing /15/ or /7/, priority 1 to others
        const priorityA =
          a.AccountGroupID === 15 || a.AccountGroupID === 7 || (a?.path||'').includes('/15/') || (a?.path||'').includes('/7/') ? 0 : 1;
        const priorityB = 
          b.AccountGroupID === 15 || b.AccountGroupID === 7 || (b?.path||'').includes('/15/') || (b?.path||'').includes('/7/') ? 0 : 1;

        // If priorities are different, sort by priority (0 comes before 1)
        if (priorityA !== priorityB) {
          return priorityA - priorityB;
        }
        // If priorities are same, sort alphabetically by label
        return a.label.localeCompare(b.label);
      });
    } else {
      //  if not show filter others out
      return Option.filter((elem) => {
        if (filter.includes(elem.AccountGroupID) || filter.some(num => (elem?.path||'')?.slice(0,-1).includes(`/${num}/`))) {
          return elem;
        }
      });
    }
  };

  return (
    <>
      <Autocomplete
        openOnFocus
        id={id}
        disableClearable={disableClearable === true}
        ListboxProps={{
          style: { paddingTop: 0 }, // Ensure top padding is removed
        }}
        options={[
          "Add Accounts",
          ...sortOptionsByAccountGroupID(Option),
          "Show All Accounts",
        ]}
        isOptionEqualToValue={isOptionEqualToValue}
        disabled={disabled}
        clearIcon={
          value !== "" ? <ClearIcon style={{ fontSize: "20px" }} /> : null
        }
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        size="small"
        renderOption={(props, option) => (
          <>
            {option === "Add Accounts" ? (
              <MenuItem
                value={"addAccount"}
                onClick={(e) => {
                  e.stopPropagation();
                  addAccountModal(true);
                }}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "sticky",
                  mt: "0px !important",
                  top: "0px !important",
                  backgroundColor: grey[50],
                  "&:hover": {
                    backgroundColor: grey[200],
                  },
                }}
              >
                <AddBox
                  fontSize="small"
                  sx={{
                    marginRight: "5px",
                    color: "primary.main",
                  }}
                />
                <ListItemText
                  sx={{ color: "primary.main" }}
                  primary={"Add Accounts"}
                />
              </MenuItem>
            ) : option === "Show All Accounts" ? (
              <MenuItem
                value={"showAllAccounts"}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  position: "sticky",
                  bottom: "-7.5px",
                  bottom: "-8px",
                  mb: "-8px",
                  zIndex: 1,
                  ml: "-10px",
                  backgroundColor: grey[50],
                  "&:hover": {
                    backgroundColor: grey[200],
                  },
                }}
                onClick={(e) => {
                  setDisplayAllAccounts(!displayAllAccounts);
                }}
              >
                <Checkbox
                  checked={displayAllAccounts}
                  fontSize="small"
                  sx={{
                    marginRight: "5px",
                    color: "primary.main",
                  }}
                  onChange={(e) => {
                    e.stopPropagation();
                    if (e.target.checked == true) {
                      setDisplayAllAccounts(true);
                    } else {
                      setDisplayAllAccounts(false);
                    }
                  }}
                />
                <ListItemText
                  sx={{ color: "primary.main" }}
                  primary={"Show All Accounts"}
                />
              </MenuItem>
            ) : (
              <li {...props}>
                <span>
                  <b>{option.label}</b>{" "}
                  {option?.groupName?.length ? (
                    <i>({option?.groupName?.trim()})</i>
                  ) : (
                    ""
                  )}
                </span>
              </li>
              // <MenuItem
              //     {...props}
              //     key={option.value}
              //     value={option.value}
              // >
              //     <ListItemText primary={<span  ><b>{option.label}</b> {option?.groupName?.length ? <i>({option?.groupName?.trim()})</i> : ""}</span>} />
              // </MenuItem>
            )}
          </>
        )}
        renderInput={(params) => (
          <TextField
            error={error}
            sx={{
              ".css-1n4twyu-MuiInputBase-input-MuiOutlinedInput-input": {
                padding: "8.5px 7px",
              },
              ".css-l2dxek-MuiInputBase-root-MuiOutlinedInput-root": {
                fontSize: "14px",
              },
              label: {
                fontSize: "14px",
              },
              ".css-lnk63-MuiButtonBase-root-MuiMenuItem-root": {
                fontSize: "14px",
              },
              ".css-1atz3nw-MuiFormLabel-root-MuiInputLabel-root": {
                color: "input.font",
              },
              ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                borderColor: "input.border",
              },
              ".css-1jiigs4-MuiFormLabel-root-MuiInputLabel-root": {
                color: "input.font",
              },
              ".css-14qz1ij-MuiListItemText-root": {
                margin: "0px",
              },
              ".css-wgai2y-MuiFormLabel-asterisk": {
                color: "danger.main",
              },
              "& .MuiAutocomplete-endAdornment svg": {
                 color: "black",
               },
            }}
            label={label}
            InputLabelProps={{
              shrink: true,
            }}
            {...params}
          />
        )}
        onInputChange={(e, newInputValue) => {
          setDisplayAllAccounts(newInputValue?.length > 0);
        }}
      />
    </>
    
  );
};
